import { BellAlertIcon, CheckBadgeIcon, ExclamationCircleIcon, ExclamationTriangleIcon, SparklesIcon } from "@heroicons/react/24/outline";

export const notificationVariants = {
  default: {
    backgroundColor: "#f8fafc",
    textColor: "#334155",
    icon: BellAlertIcon,
    label: "Default",
  },
  info: {
    backgroundColor: "#dbeafe",
    textColor: "#1e40af",
    icon: ExclamationCircleIcon,
    label: "Info",
  },
  success: {
    backgroundColor: "#dcfce7",
    textColor: "#15803d",
    icon: CheckBadgeIcon,
    label: "Success",
  },
  warning: {
    backgroundColor: "#fef3c7",
    textColor: "#d97706",
    icon: ExclamationTriangleIcon,
    label: "Warning",
  },
  danger: {
    backgroundColor: "#fee2e2",
    textColor: "#dc2626",
    icon: ExclamationCircleIcon,
    label: "Danger",
  },
  custom: {
    backgroundColor: "#ffffff",
    textColor: "#000000",
    icon: SparklesIcon,
    label: "Custom",
  },
};
